var _rect, _rect2, _path, _path2, _path3, _circle, _g, _circle2, _path4, _rect3, _rect4, _rect5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPermissionIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 145,
  height: 100,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48.264,
  height: 48.264,
  x: 49.402,
  y: 21.462,
  fill: "#A14335",
  rx: 12
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 48.264,
  height: 48.264,
  x: 43.833,
  y: 17.75,
  fill: "#F56B57",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M79.283 50.788V47.51l-10.642.005v3.277h6.648v3.52a8.535 8.535 0 0 1-5.13 1.709c-4.721 0-8.551-3.805-8.551-8.506 0-4.173 3.03-7.64 7.019-8.361v-4.009c-6.2.746-11.003 5.994-11.003 12.365 0 6.89 5.617 12.471 12.54 12.471a12.54 12.54 0 0 0 9.119-3.912v-5.282Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M76.055 39.154v-4.013l-6.412.005v4.013h2.413l-.038 3.931a8.524 8.524 0 0 1-5.087 1.67c-1.301 0-2.53-.3-3.637-.813a7.635 7.635 0 0 0-.887 3.563c0 .13.024.257.03.383 1.396.532 2.904.837 4.489.837.308 0 .612-.024.91-.048v-1.956h.39l.4-.005h5.102a12.474 12.474 0 0 0 2.313-1.898l.014-5.669ZM66.931 27.753c1.826 0 3.517.566 4.904 1.54.95-.945 2.106-1.748 3.406-2.373a12.519 12.519 0 0 0-8.31-3.137c-6.923 0-12.54 5.582-12.54 12.471 0 3.016 1.075 5.776 2.862 7.935a13.18 13.18 0 0 1 1.975-4.26 8.401 8.401 0 0 1-.848-3.675c0-4.696 3.83-8.501 8.551-8.501Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2CBE96",
  strokeDasharray: "2 2",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M45.23 54.696c-9.267 7.734-14.288 14.466-12.416 17.708 3.13 5.42 24.342-.967 47.38-14.268 23.038-13.301 39.176-28.478 36.047-33.898-1.852-3.207-10.031-2.281-21.172 1.763"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 121.75,
  cy: 22,
  r: 17,
  fill: "#3863F0"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#permissionIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M121.75 11.375a7.432 7.432 0 0 0-7.438 7.438c0 4.43 4.697 10.54 6.63 12.866.425.51 1.201.51 1.626 0 1.923-2.326 6.62-8.436 6.62-12.866a7.432 7.432 0 0 0-7.438-7.438Zm0 10.094a2.657 2.657 0 0 1 0-5.313 2.657 2.657 0 0 1 0 5.313Z"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 77.25,
  r: 17,
  fill: "#3863F0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M14.897 75.133a8.8 8.8 0 0 1 17.6 0v4.4a8.8 8.8 0 0 1-17.6 0v-4.4Zm8.382 3.499-.814.814a.442.442 0 0 1-.62.004l-.073-.07a12.502 12.502 0 0 1-1.3-1.51 7.854 7.854 0 0 1-.863-1.5c-.207-.501-.312-.981-.312-1.439 0-.299.052-.585.158-.849.106-.268.273-.515.506-.735.282-.277.59-.413.915-.413.123 0 .247.026.357.079a.717.717 0 0 1 .294.246l1.021 1.44c.08.11.137.21.176.307.04.093.062.185.062.269 0 .105-.03.21-.092.312-.058.101-.141.207-.247.312l-.334.348a.235.235 0 0 0-.07.176.4.4 0 0 0 .013.101l.017.044.018.044c.079.145.215.335.409.563.198.23.41.463.638.696l.068.066.068.066a.44.44 0 0 1 .005.629Zm4.739 1.86c.044-.123.066-.25.066-.373a.903.903 0 0 0-.07-.344.668.668 0 0 0-.243-.281l-1.456-1.034a1.702 1.702 0 0 0-.308-.172.702.702 0 0 0-.269-.057c-.11 0-.211.03-.312.092a1.35 1.35 0 0 0-.317.247l-.334.33a.242.242 0 0 1-.18.075.304.304 0 0 1-.15-.036l-.04-.017a2.472 2.472 0 0 1-.326-.211l-1.439 1.438c.163.137.335.264.506.392a7.727 7.727 0 0 0 1.514.871c.506.216.986.322 1.435.322.303 0 .585-.058.845-.163l.006-.002a1.984 1.984 0 0 0 .728-.521c.128-.142.225-.291.3-.45.017-.035.03-.07.044-.105Z",
  clipRule: "evenodd"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3.788,
  height: 2.104,
  x: 13.167,
  y: 72.737,
  fill: "#223B90",
  rx: 1.052
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 3.788,
  height: 2.104,
  x: 13.167,
  y: 76.741,
  fill: "#223B90",
  rx: 1.052
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 3.788,
  height: 2.104,
  x: 13.167,
  y: 80.746,
  fill: "#223B90",
  rx: 1.052
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "permissionIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M109 9.25h25.5v25.5H109z"
})))));
export default SvgPermissionIcon;